import { Sun, Moon } from "lucide-react";
import { cn } from "@/lib/cn";
import { useTheme } from "@/theme/ThemeProvider";

// Segmented sun/moon toggle: both options are always visible and the active theme
// is highlighted (surface-2 pill + amber icon). Flips Garage Dark ↔ daylight.
export function ThemeToggle() {
  const { theme, setTheme } = useTheme();
  return (
    <div
      className="flex items-center gap-0.5 rounded-full border border-edge-3 bg-surface p-0.75"
      role="group"
      aria-label="Theme"
    >
      {(["light", "dark"] as const).map((t) => {
        const Icon = t === "light" ? Sun : Moon;
        const active = theme === t;
        return (
          <button
            key={t}
            onClick={() => setTheme(t)}
            aria-pressed={active}
            aria-label={t === "light" ? "Light theme" : "Dark theme"}
            className={cn(
              "grid size-7 place-items-center rounded-full transition-colors",
              // amber-ink (not amber) so the active icon keeps contrast on the
              // light active-segment background too: bright amber on dark, darker
              // gold on light.
              active ? "bg-surface-2 text-amber-ink" : "text-muted hover:text-ink",
            )}
          >
            <Icon size={15} />
          </button>
        );
      })}
    </div>
  );
}
